import { getViemClients, } from "@bracket/contractor-next";
import type { TokenIdentifier, } from "@bracket/chainography";

import {
	getContractWithABI,
	getTokenDefinition,
	type ValidChainId,
} from "@bracket/chainography";
import type { Config, } from "wagmi";

export declare type CalculateBurnProps = {
	token: TokenIdentifier;
	amount: bigint;
	chain?: ValidChainId;
	chainId?: ValidChainId;
	config?: Config;  
};




/**
 * Calculates the amount of tokens to burn based on the input amount and token
 * @summary For brktETH tokens, calculates the burn amount that will be received for a given input amount
 * @param {Object} params - The parameters for calculating burn amount
 * @param {TokenIdentifier} params.token - The collateral token being received from this burn
 * @param {bigint} params.amount - The amount brktETH to burn
 * @param {ValidChainId} [params.chainId=1] - The chain ID to use (defaults to 1)
 * @param {ValidChainId} [params.chain] - Deprecated parameter, use chainId instead
 * @param {Config} [params.config] - Optional wagmi config for frontend usage
 * @returns {Promise<bigint>} The calculated collateral to expect from this burn
 * @throws {Error} If the contract call fails or returns an invalid value
 */
export const calculateBurn = async ({
	token,
	amount,
	chain,
	chainId = 1,
	config,
}: CalculateBurnProps): Promise<bigint> => {

	try {

		if(chain) {
			console.warn("calculateBurn: chain is deprecated, use chainId instead");
			chainId = chain;
		}

    if(chainId !== 1)
      throw new Error("mint supports only chain 1");

    const [vclient, _] = await getViemClients({ config, chainId, });
		const tok = getTokenDefinition(token, chainId);
		const [address, abi] = getContractWithABI("BrktETH", chainId);
		const args = ["ETH", "WETH"].includes(tok.symbol) ? [amount] : [amount, tok.address];
    const result = await vclient.readContract({
			address,
			abi,
			functionName: "calculateBurn",
			args,
		});

		if(typeof result === "bigint") {
			return result;
		}

    throw new Error("contract did not return the expected value as a bigint");

  } catch (err) {

    throw new Error(`@bracket/chainography/brktETH/calculateBurn: ${err.message}`);
	}
};
